import {createContext} from 'react'
import type {EstablishedAhpSession, EstablishedAhpSessionViewSnapshot} from '@github-ui/ahp-session-client/contracts'

/**
 * The host owns the established session. Shared UI only makes that already
 * bound contract available to the surfaces rendered below it.
 */
export const EstablishedAhpSessionContext = createContext<EstablishedAhpSession | undefined>(undefined)
export const EstablishedAhpSessionSnapshotContext = createContext<EstablishedAhpSessionViewSnapshot | undefined>(
  undefined,
)
